import { useLayoutEffect as g, useEffect as a, useRef as f, useState as d, useCallback as l, createRef as h, useMemo as E } from "react";
import { smoothScrollToElementId as R } from "../scroll.js";
import { getFromLocalStorage as w, saveToLocalStorage as L } from "../localStorage.js";
import { noop as C } from "../functions.js";
import { isBrowser as v } from "../env.js";
const P = v() ? g : a, b = (e) => {
  const t = f(e);
  return a(() => {
    t.current = e;
  }, [e]), t;
}, z = (e) => {
  const { value: t, initialValue: n, onChange: r } = e, [o, s] = d(t ?? n), c = b(r), i = t !== void 0 ? t : o, u = l(
    (p) => {
      var m;
      (m = c.current) == null || m.call(c, p), s(p);
    },
    [c]
  );
  return [i, u];
}, B = (e) => {
  const [t, n] = d(e), r = f(void 0);
  a(() => {
    r.current && (r.current(t), r.current = void 0);
  }, [t]);
  const o = l(
    (s, c) => {
      r.current = c, n(s);
    },
    []
  );
  return [t, o];
}, F = () => {
  const e = f(/* @__PURE__ */ new Map());
  return [l((n) => {
    const r = e.current.get(n);
    if (r)
      return r;
    const o = h();
    return e.current.set(n, o), o;
  }, [])];
}, W = (e, t) => {
  const [n, r] = d(e);
  return a(() => {
    const o = setTimeout(() => {
      r(e);
    }, t);
    return () => {
      clearTimeout(o);
    };
  }, [e, t]), n;
}, S = (e, t, n = {}) => {
  const { ignoreFirstCallInDevMode: r, ignoreSecondCallInDevMode: o } = n, s = f(!1), c = f(!1);
  a(() => {
    if (process.env.NODE_ENV === "development") {
      const i = !s.current, u = s.current && !c.current;
      if (i && (s.current = !0), u && (c.current = !0), i && r || u && o)
        return;
    }
    e();
  }, t);
}, T = (e, t) => {
  S(e, [], t);
}, x = (e) => {
  a(() => e, []);
}, N = (e) => {
  const [t, n] = d(!1);
  return T(() => {
    n(!0);
  }, e), t;
}, U = () => {
  const [e, t] = d(!1), n = l(() => t(!0), []), r = l(() => t(!1), []);
  return [e, { onPointerEnter: n, onPointerLeave: r }];
}, k = (e) => {
  const t = f(e), n = f(e);
  return t.current !== e && (n.current = t.current, t.current = e), n.current;
}, A = (e) => {
  const t = b(e);
  a(() => {
    const n = (r) => {
      let o;
      if (typeof t.current == "function" && (o = t.current(r)), r.defaultPrevented && (r.returnValue = ""), typeof o == "string")
        return r.returnValue = o, o;
    };
    if (v())
      return window.addEventListener("beforeunload", n), () => {
        window.removeEventListener("beforeunload", n);
      };
  }, [t]);
}, _ = () => {
  a(() => {
    if (!v())
      return;
    const { hash: e } = window.location;
    if (e) {
      const t = e.replace("#", "");
      R(t);
    }
  });
};
function j(e, t) {
  const [n, r] = d(
    () => w(e) ?? t
  ), o = l(
    (s) => {
      r(s), L(e, s);
    },
    [e]
  );
  return [n, o];
}
const V = (e = {}) => {
  const { ref: t, onResize: n = C, enabled: r = !0 } = e, o = f(null), s = t ?? o, c = b(n), i = E(() => {
    if (v() && r)
      return new ResizeObserver((u) => {
        var m;
        const p = u[0];
        p && ((m = c.current) == null || m.call(c, p));
      });
  }, [r]);
  return a(() => {
    const u = s.current;
    if (v() && i && u)
      return i.observe(u), () => {
        i.unobserve(u), i.disconnect();
      };
  }, [i]), { ref: s };
}, q = () => {
  const [e, t] = d(!1), n = l((o) => {
    !v() || !navigator.clipboard || navigator.clipboard.writeText(o).then(() => {
      t(!0);
    }).catch(console.error);
  }, []), r = l(() => {
    t(!1);
  }, []);
  return { isCopied: e, setIsCopied: t, copyToClipboard: n, resetIsCopied: r };
}, y = (e) => {
  const { ref: t, onPointerDownOutside: n } = e, r = l(
    (o) => {
      t != null && t.current && !t.current.contains(o.target) && n();
    },
    [n, t]
  );
  a(() => {
    if (v())
      return document.addEventListener("pointerdown", r), () => {
        document.removeEventListener("pointerdown", r);
      };
  }, [r]);
}, G = (e, t) => {
  const n = e == null ? void 0 : e.current, { initialHeight: r = 0, observerEnabled: o = !0 } = t ?? {}, [s, c] = d(
    n ? n.offsetHeight : r
  );
  return V({
    ref: e,
    enabled: o,
    onResize: (i) => {
      const u = i.target;
      c(u.offsetHeight);
    }
  }), s;
}, J = (e, t = {}) => {
  const { intervalTime: n = 1e3, enabled: r = !0 } = t, [o, s] = d(e), c = f();
  return a(() => {
    s(e);
  }, [e]), a(() => {
    if (r)
      return c.current = setInterval(() => {
        s((i) => {
          const u = i - n;
          return u <= 0 ? (clearInterval(c.current), 0) : u;
        });
      }, n), () => {
        clearInterval(c.current);
      };
  }, [e, n, r]), o;
}, K = (e, t, n, r = {}) => {
  const { enabled: o = !0, ...s } = r;
  a(() => {
    if (o)
      return e.addEventListener(t, n, s), () => {
        e.removeEventListener(t, n, s);
      };
  }, [e, t, n, o]);
};
export {
  A as useBeforeUnload,
  q as useClipboard,
  J as useCountdown,
  W as useDebouncedValue,
  z as useDerivedState,
  T as useDidMount,
  S as useEffectDev,
  K as useEventListener,
  G as useHeight,
  U as useHover,
  N as useIsMounted,
  P as useIsomorphicLayoutEffect,
  j as useLocalStorageState,
  y as usePointerDownOutside,
  k as usePrevious,
  F as useRefs,
  V as useResizeObserver,
  _ as useScrollToAnchor,
  B as useStateWithCallback,
  b as useValueRef,
  x as useWillUnmount
};
